import { HUser, isAndroid } from '@haidilao-private/jsbridge';
import { TOKEN_KEY } from '@/helper/common/constant';
import { isEnv, getQuery } from '@/utils';
import { LoginPath } from '@/helper/common/common';
// 获取token
export const getToken = () => {
  const env: string = isEnv();
  let token: any = '';
  switch (env) {
    case 'App':
      token = new Promise((resolve, reject) => {
        HUser.getUserInfo((res: any) => {
          if (res && res.token) {
            resolve(res.token);
          } else {
            isAndroid && Login(); //如果取不到ios会自动吊起来登录
            reject(`登录信息获取失败:${res.error}`);
          }
        });
      });
      break;
    case 'H5':
      token = new Promise((resolve, reject) => {
        const userInfo = sessionStorage.getItem(TOKEN_KEY);
        const token = userInfo ? JSON.parse(userInfo).value : null;
        if (token) {
          resolve(token);
        } else {
          Login();
          reject('登录信息获取失败');
        }
      });
      break;
    case 'MiniApp':
    case 'alipay':
      token = new Promise((resolve, reject) => {
        const token = getQuery(TOKEN_KEY);
        if (token) {
          resolve(token);
        } else {
          Login();
          reject('登录信息获取失败');
        }
      });
      break;
    default:
      token = null;
  }
  return token;
};

// 吊起登陆
export const Login = () => {
  const platform: string = isEnv();
  switch (platform) {
    case 'H5':
      window.location.href = LoginPath(
        `${location.origin}${location.pathname}?source=H5#/signIndex`,
        '签到享好礼',
      );
      break;
    case 'MiniApp':
      window.wx.miniProgram.switchTab({ url: '/pages/index/index' });
      break;
    case 'App':
      HUser.loginOut();
      break;
    case 'alipay':
      window.my.miniProgram.switchTab({
        url: '/pages/index/index',
      });
      break;
    default:
      window.location.href = LoginPath(
        `${location.origin}${location.pathname}?source=H5#/signIndex`,
        '签到享好礼',
      );
      break;
  }
};
